import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Ladder } from '../../../models/ladder.model';
import { Level } from '../../../models/level.model';
import { Score } from '../../../models/score.model';

@Component({
  selector: 'admin-tourney',
  templateUrl: './tourneybuilder.component.html',
  styleUrls: ['./tourneybuilder.component.scss']
})
export class AdminTournamentBuilderComponent implements OnInit {
  public pairingForm: FormGroup;
  public result: string;
  public ladders: Ladder[] = [];
  public levels: Level[] = [];
  public playerCount: number = 8;
  public playerCountOptions: number[] = [4, 8, 16];
  public isProcessing: boolean = false;

  constructor(private http: HttpClient, private fb: FormBuilder) {
    this.pairingForm = fb.group({
      ladderId: new FormControl(''),
      levelId: new FormControl(1),
      playerCount: new FormControl(8),
      players: new FormArray([
      ])
    });
    this.pairingForm.controls.ladderId.valueChanges.subscribe(
      (newVal) => {
        this.pairingForm.controls.players.reset();
        //this.getPlayers(newVal, this.pairingForm.value.levelId);
        this.getLevels(newVal);
      }
    );
    this.pairingForm.controls.levelId.valueChanges.subscribe(
      (newVal) => {
        this.pairingForm.controls.players.reset();
        this.getPlayers(this.pairingForm.value.ladderId, newVal);
      }
    );
    this.pairingForm.controls.playerCount.valueChanges.subscribe(
      (newVal) => {
        if (newVal && newVal !== this.playerCount) {
          this.playerCount = newVal;
          this.resetPlayersFormArray();
          // If ladder and level are already selected, re-fetch players to fill the new form array
          const ladderId = this.pairingForm.value.ladderId;
          const levelId = this.pairingForm.value.levelId;
          if (ladderId && levelId) {
            this.getPlayers(ladderId, levelId);
          }
        }
      }
    );
  }

  private resetPlayersFormArray() {
    // Clear existing controls
    while (this.players.length !== 0) {
      this.players.removeAt(0);
    }
    // Add new controls based on playerCount
    for (let i = 0; i < this.playerCount; i++) {
      this.players.push(new FormControl(''));
    }
    // Reset the form values
    this.pairingForm.controls.players.reset();
  }

  private getLevels(ladderId: string) {
    if (ladderId.length == 0) return;
    const headers = new HttpHeaders();
    let params = new HttpParams().set('_ladderId', ladderId)

    this.http.get<Level[]>(`/activeLevelsByLadderId?ladderId=${ladderId}`, { headers, params }).subscribe(
      (resp) => {
        this.levels = resp.map(l => new Level(l));
      }
    );
  }

  public playerScoreResp: Score[] = [];
  private getPlayers(ladderId: string, levelId: number) {
    if (ladderId.length == 0 || levelId == 0) return;
    const headers = new HttpHeaders();
    let params = new HttpParams()
      .set('_ladderId', ladderId)
      .set('_levelId', levelId.toString());
    this.http.get<Score[]>(`/score`, { headers, params }).subscribe(
      (resp2) => {
        this.playerScoreResp = resp2;
        const playersArray = this.pairingForm.controls.players as FormArray;
        const maxPlayersToFill = Math.min(this.playerCount, resp2.length);
        
        // Fill in actual players (as many as available, up to playerCount)
        for (let i = 0; i < maxPlayersToFill && i < playersArray.length; i++) {
          playersArray.controls[i].setValue(resp2[i].opponent.id);
        }

        // Only fill in BYE players for positions that don't have real players
        if (resp2.length < this.playerCount) {
          const byeId = levelId < 10 
            ? "00000000-0000-0000-0000-00000000000" + levelId
            : "00000000-0000-0000-0000-0000000000" + levelId;
          
          // Fill remaining positions with BYEs
          for (let i = resp2.length; i < this.playerCount && i < playersArray.length; i++) {
            playersArray.controls[i].setValue(byeId);
          }
        }
      }
    )
  }






  get players(): FormArray {
    return this.pairingForm.get("players") as FormArray
  }
  ngOnInit() {
    this.playerCount = this.pairingForm.value.playerCount || 8;
    for (let i = 0; i < this.playerCount; i++) {
      this.players.push(new FormControl(''));
    }
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders.length = 0;
        for (const l of resp) {
          this.ladders.push(new Ladder(l));
        }
      }
    )
    // this.http.get<Level[]>('/levels').subscribe(
    //   (resp) => {
    //     this.levels.length = 0;
    //     for (const l of resp) {
    //       this.levels.push(new Level(l));
    //     }
    //   }
    // )
  }

  public doit(evt) {
    if (this.isProcessing) return;

    //return this.skillsForm.get("skills") as FormArray

    const values = this.pairingForm.value;
    // Use generic endpoint which handles any number of players (4, 8, 16, etc.)
    const endpoint = `/Pairing/PairTournamentGeneric`;
    // Remove playerCount from the payload as it's not part of the DTO
    const payload = {
      ladderId: values.ladderId,
      levelId: values.levelId,
      players: values.players
    };
    
    this.isProcessing = true;
    this.result = null;
    
    this.http.post(endpoint, payload).subscribe(
      (resp: { result: string }) => {
        console.log(resp)
        this.result = resp.result;
        this.isProcessing = false;
      },
      (err) => {
        console.error(err)
        this.isProcessing = false;
        this.result = err.error?.message || 'An error occurred while creating the tournament pairings.';
      }
    )
    console.log(this.pairingForm.value.player)
  }

}
